// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Yo-z","badgeLink":"Zo-z","category":"_o-z"};